import * as React from 'react';
import { Icon } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export let ContentSectionIconName = /*#__PURE__*/function (ContentSectionIconName) {
  ContentSectionIconName["Detail"] = "EditNote";
  ContentSectionIconName["Versions"] = "SizeLegacy";
  ContentSectionIconName["Rights"] = "Money";
  ContentSectionIconName["Screening"] = "RedEye";
  ContentSectionIconName["Editorial"] = "News";
  ContentSectionIconName["Metadata"] = "BulletedList";
  ContentSectionIconName["Images"] = "ImageCrosshair";
  ContentSectionIconName["Attachments"] = "Attach";
  ContentSectionIconName["Admin"] = "Admin";
  ContentSectionIconName["Scout"] = "Airplane";
  ContentSectionIconName["Shortlist"] = "FavoriteList";
  return ContentSectionIconName;
}({});
export const ContentSectionIcon = /*#__PURE__*/React.memo(_ref => {
  let {
    name
  } = _ref;
  return /*#__PURE__*/_jsx(Icon, {
    iconName: name
  });
});